import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { UliItemFacade } from './uli-item.facade';
import { UliItemActionParams } from '../models/uli-item-overview.model';

@Injectable({
  providedIn: 'root',
})
export class UliItemGuard {
  constructor(private uliItemFacade: UliItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { id },
      queryParams: { compartmentId, type },
    } = route;
    const uliParams: UliItemActionParams = {
      uli: id,
      compartmentId,
      type,
    };

    return checkStoreState(this.uliItemFacade, uliParams);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.uliItemFacade);
  }
}
